import { Store } from '@jwplayer/fe-common/module/store/react';

export const UiStore = new Store({
  sideNavCollapsed: false,

  /**
   * If any page is using a `Prompt` component to prevent a page navigation,
   * this value will reflect that component's blocking state. We can use
   * it to globally check if navigation is blocked anywhere in the app.
   */
  navigationBlocked: false,

  /**
   * Certain pages, like Users & Properties or Developer tools are not specific to any
   * property or site, so they have a different UX and navigation type to what property-related
   * pages have, like the Media library or Players page. This value will differentiate the two types
   * of pages so the UI can change accordingly.
   */
  isPropertyDashboard: true,
});
